import React from 'react';
import {
  Title,
  LandingText,
  // CustomButton,
  OmnichannelTitle,
  Text,
} from './style';

function LandingMessage() {
  return (
    <LandingText>
      <OmnichannelTitle>i9.Omnichannel</OmnichannelTitle>
      <Title>Proporcione uma excelente experiência ao cliente</Title>
      <Text>
        Interaja com clientes independentemente de como eles entram em contato
        com você. Crie relações que duram e melhore seus resultados.
      </Text>
      {/* <CustomButton text="Veja Mais" lightText /> */}
    </LandingText>
  );
}

export default LandingMessage;
